<template>
  <v-col class="pa-0 my-auto">
    <v-row class="ma-0 pb-12 mx-auto fit-content">
      <FransysSignature />
    </v-row>
    <v-row class="ma-0">
      <LoginBar class="ma-auto" />
    </v-row>
  </v-col>
</template>

<script setup lang="ts">
import FransysSignature from '@shared/components/UIElements/FransysSignature.vue';
import LoginBar from '@/components/LoginBar.vue';
</script>
